/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    // Shared functions
    function sharedFn() {
        function stringTrim(str) {
            return str == null ? '' : (str + '').replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }

        function isLowStock() {
            var ctaBtn = document.querySelector('.product-section:not(.is-modal) button.btn--full[type="submit"]');
            if (!ctaBtn || stringTrim(ctaBtn.textContent).toLowerCase().includes('sold out')) {
                return false;
            }

            var productNameNode = document.querySelector('.h2.product-single__title');
            if (!productNameNode || stringTrim(productNameNode.textContent).toLowerCase().includes('pre order')) {
                return false;
            }

            var variantSelect = document.querySelector('.variant-wrapper--dropdown select');
            if (!variantSelect) {
                return false;
            }

            var selectedOption = variantSelect.options[variantSelect.selectedIndex];
            if (selectedOption && selectedOption.label.toLowerCase().includes('pre order')) {
                return false;
            }

            var selectedVariant = _BISConfig.product.variants[variantSelect.selectedIndex];
            if (!selectedVariant) {
                return false;
            }

            var quantity = variantStock[selectedVariant.id];
            if (quantity >= 5) {
                return false;
            }

            if (quantity < 1) {
                return false;
            }

            window.w25StockQuantity = quantity;
            return true;
        }

        function checkLowStock(callback) {
            Mojito.utils.waitUntil(
                function () {
                    return (
                        window._BISConfig &&
                        _BISConfig.product &&
                        _BISConfig.product.variants &&
                        window.variantStock
                    );
                },
                function () {
                    if (isLowStock()) {
                        window.w25IsLowStock = true;
                    }
                    callback();
                }
            );
        }

        return { isLowStock, checkLowStock };
    }

    // Treatment logic
    function treatment(shared) {
        var lowStockNode;

        function transformLowStock() {
            var ctaBtn = document.querySelector('.product-section:not(.is-modal) button.btn--full[type="submit"]');

            if (shared.isLowStock()) {
                if (!lowStockNode) {
                    lowStockNode = document.createElement('div');
                    lowStockNode.className = 'low-stock';
                    ctaBtn.insertAdjacentElement('beforebegin', lowStockNode);
                }

                if (window.w25StockQuantity === 4) {
                    lowStockNode.innerHTML = '⏰ Less than <span>5 in stock</span>';
                } else if (window.w25StockQuantity === 3) {
                    lowStockNode.innerHTML = '⏰ Less than <span>4 in stock</span>';
                } else {
                    lowStockNode.innerHTML = '⏰ Only <span>2 items left</span>';
                }

                lowStockNode.style.display = 'block';
            } else if (lowStockNode) {
                lowStockNode.style.display = 'none';
            }
        }

        if (window.w25IsLowStock) {
            transformLowStock();
        }

        Mojito.utils.waitForElement('.variant-wrapper--dropdown select', function (variantSelect) {
            variantSelect.addEventListener('change', transformLowStock);
        });
    }

    // Trigger logic
    function trigger(shared) {
        if (!/\/products\//gi.test(location.pathname)) {
            return;
        }

        Mojito.utils.domReady(function () {
            shared.checkLowStock(function () {
                if (window.w25IsLowStock) {
                    treatment(shared);
                }
            });
        });
    }

    (function () {
        var shared = sharedFn();

        trigger(shared);
    })();
})();
